import format from "date-fns/format";
import React from "react";
import { useTranslation } from "react-i18next";

import Modal from "@/components/Modal";
import { Spacer } from "@/components/common";
import { ScheduleHistory } from "@/components/list/Schedule/types";

type Props = {
  title: string;
  target: string;
  historyList: ScheduleHistory[];
  onClose: () => void;
};

export const ScheduleHistoryDialog = ({ title, target, historyList, onClose }: Props) => {
  const { t } = useTranslation();

  return (
    <Modal title={t("revision_history")} closeHandler={onClose}>
      <div className="modal-body w-[500px] py-[20px] px-[50px]">
        <div className="flex justify-center items-center text-[14px] text-center">
          {title}：{target}
        </div>
        <Spacer y="15px" />
        {historyList.map((item, index) => (
          <React.Fragment key={index}>
            <div className="bg-white border-[1px] border-solid border-gray-300 p-[5px]">
              <div className="whitespace-pre-line min-h-[18px]">{item.content_after}</div>
              <Spacer y="8px" />
              <p className="text-[#cccccc]">
                <span>{format(new Date(item.insert_date), "yyyy/MM/dd HH:mm:ss")}</span>
                <span className="ml-10">{item.insert_user_name}</span>
              </p>
            </div>
            {index !== historyList.length - 1 && (
              <div className="flex justify-center items-center my-[5px]">
                <img src="./img/icon-history-arrow.svg" className="icon h-[20px]" />
              </div>
            )}
          </React.Fragment>
        ))}
      </div>
      <div className="modal-footer">
        <button type="button" className="btn btn-gray" onClick={onClose}>
          {t("close")}
        </button>
      </div>
    </Modal>
  );
};
